import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickNavigation = () => {
  const navigate = useNavigate();

  // Labels are the plain-English word a teacher would use to describe
  // the task, not the app's internal noun. "Log Behavior" reads as an
  // action ("this is where I go to log behavior"), which is what a
  // teacher actually wants. "Students", "Goals", "Reports" are the
  // shortest labels that still convey what's inside — no need to add
  // "Profiles" or "and Analytics" to the tile text.
  const navigationItems = [
    {
      id: 'student-profiles',
      title: 'Students',
      subtitle: 'Add or edit',
      icon: 'Users',
      path: '/student-profile-management',
      color: 'bg-blue-500'
    },
    {
      id: 'iep-goals',
      title: 'IEP Goals',
      subtitle: 'Track progress',
      icon: 'Target',
      path: '/iep-goals-and-objectives-tracking',
      color: 'bg-green-500'
    },
    {
      id: 'behavioral-incidents',
      title: 'Log Behavior',
      subtitle: 'What happened & why',
      icon: 'AlertTriangle',
      path: '/behavioral-incident-logging',
      color: 'bg-orange-500'
    },
    {
      id: 'reports',
      title: 'Reports',
      subtitle: 'Print or export',
      icon: 'FileText',
      path: '/reports-and-analytics',
      color: 'bg-purple-500'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Access</h2>
      
      <div className="grid grid-cols-2 gap-3">
        {navigationItems?.map((item) => (
          <Button
            key={item?.id}
            variant="ghost"
            onClick={() => handleNavigation(item?.path)}
            className="p-4 h-auto border border-gray-100 hover:border-gray-200 hover:shadow-sm transition-all duration-200 flex-col gap-2 text-center"
          >
            <div className={`w-10 h-10 ${item?.color} rounded-lg flex items-center justify-center mb-2`}>
              <Icon name={item?.icon} size={20} className="text-white" />
            </div>
            <span className="text-sm font-medium text-gray-800 leading-tight">
              {item?.title}
            </span>
            {item?.subtitle && (
              <span className="text-xs text-gray-500 leading-tight">
                {item.subtitle}
              </span>
            )}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickNavigation;